<template>
  <a-spinner :spinning="spinning">
  <div>
      <br/>
      <div>
        <base-checkbox class="mb-3" v-model="menus.override_receipt_logo">Enable Receipt Logo</base-checkbox>
      </div>
      <!-- receipt logo -->

      <div v-if="menus.override_receipt_logo" class="row">
          <div class="col">
              <!-- ant upload here -->
              <base-input label="Upload Logo">
                <br/>
                <a-upload action=""
                  accept="image/*" 
                  listType="picture-card"
                  :fileList="menus.fileList"
                  :max-count="1"
                  :customRequest="customUploadRequest"
                  @preview="handlePreview"
                  @change="handleUploadChange"
                  :remove="handleRemove"
                  >
                  <div v-if="menus.fileList.length < 1">
                    <div class="ant-upload-text">Upload +</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                    <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </base-input>
              <!-- end ant upload -->
          </div>
      </div>
      <!-- logo -->

  </div>
  </a-spinner>
</template>
<script>
import { mapState } from "vuex";
import secureStorage from '../controllers/secureStorage.js';
import moment from 'moment';
import HTTPRequest from '../controllers/httpRequest.js'
import axios from 'axios';

var component_x;

export default {
  data() {
    return {
      // UPLOADER
      previewVisible: false,
      spinning: false,
      errors: [],
      previewImage: '',
      fileList: [],
      oldFile: {},
      imageLoaded: true,
      loginHistory: [],
      s3_file: '',
      override_receipt_logo: false,
      menus: {
        override_receipt_logo: false,
        fileList: []
      },
      settingCode: null
    };
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "parameters",
      "categoriesOptions",
    ]),
  },

  mounted: async function () {
    this.spinning =true
    component_x = this;
    component_x.settingCode = component_x.$attrs.settingCode;
    if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
      this.menus = this.$attrs.defaultValue
    }
    this.spinning =false
  },

  watch: {
    fileList: {
      handler: async function () {
        var configValues = {};
        this.fileList = this.menus.fileList
        configValues[this.settingCode] = this.menus;
        component_x.$emit("changeValue", configValues);
      },
      deep: true,
    },
    override_receipt_logo: function () {
      if (this.override_receipt_logo == false) {
        this.fileList = [];
      }
    },
  },

  methods: {
      handleCancel () {
          this.previewVisible = false
      },
      handleRemove(){
        this.menus.fileList = []
      },
      handlePreview (file) {
          console.log(file)
          this.previewImage = file.url || file.thumbUrl
          this.previewVisible = true
      },
      async customUploadRequest(options){
        let {data, onSuccess, onError, file, onProgress,action} = options
        const accountId = secureStorage.getItem("accountId");
        const newFileName = `${moment().format('MMDDYYhhmmss')}-${accountId}-${file.name}`
        const myRenamedFile = new File([file], newFileName);

        let dta = new FormData();
        dta.append('file', myRenamedFile);
        var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
        var config = {
            method: 'post',
            url: uploader_endpoint.endpoint+'?profile=dynamic_forms&account_name='+secureStorage.getItem("accountName"),
            // headers: {'Authorization': 'Bearer ' + "80xSM163wfD3c15Y6QvqJvOvmlCNUIOTwlrLepg3RXY"},
            headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
            data : dta,
            onUploadProgress: ({ total, loaded }) => {
                onProgress({ percent: Math.round((loaded / total) * 100) });
            },
        };

        var response_data;
        await axios(config)
            .then(function (response) {
                response_data = response.data
                file.url = response_data.path
                file.status = 'done'
                file.percent = 100
                onSuccess(null,file)
            })
            .catch(function (error) {
                onError('err',error)
                console.log(error)
            })
        this.oldFile = file
        this.fileList = []
        this.menus.fileList.push(this.oldFile)
        console.log(this.oldFile)
    },
    async handleUploadChange({file, fileList}){
      // this.menus.fileList = fileList
      if(file.status == 'uploading'){
        console.log('uploading',file)
        }
        if (file.status === 'done') {
          console.log('done',file,fileList, this.oldFile,this.fileList)
        } else if (file.status === 'error') {
          console.log('error', file)
            // show error message
        }
    }
  },
};
</script>